
export const NEW_MOTORISTA_CADASTRO = 'NEW_MOTORISTA_CADASTRO'
export const NEW_MOTORISTA_CADASTRO_SUCCESS = 'NEW_MOTORISTA_CADASTRO_SUCCESS'

export const NEW_FILTER_MOTORISTA_CADASTRO = 'NEW_FILTER_MOTORISTA_CADASTRO';
export const NEW_FILTER_MOTORISTA_CADASTRO_PENDING = 'NEW_FILTER_MOTORISTA_CADASTRO_PENDING';
export const NEW_FILTER_MOTORISTA_CADASTRO_SUCCESS = 'NEW_FILTER_MOTORISTA_CADASTRO_SUCCESS';
export const NEW_FILTER_MOTORISTA_CADASTRO_FAILURE = 'NEW_FILTER_MOTORISTA_CADASTRO_FAILURE';

export const NEW_FILTER_NEXT_PAGE_MOTORISTA_CADASTRO = 'NEW_FILTER_NEXT_PAGE_MOTORISTA_CADASTRO';
export const NEW_FILTER_NEXT_PAGE_MOTORISTA_CADASTRO_PENDING = 'NEW_FILTER_NEXT_PAGE_MOTORISTA_CADASTRO_PENDING';
export const NEW_FILTER_NEXT_PAGE_MOTORISTA_CADASTRO_SUCCESS = 'NEW_FILTER_NEXT_PAGE_MOTORISTA_CADASTRO_SUCCESS';
export const NEW_FILTER_NEXT_PAGE_MOTORISTA_CADASTRO_FAILURE = 'NEW_FILTER_NEXT_PAGE_MOTORISTA_CADASTRO_FAILURE';

export const CREATE_MOTORISTA_CADASTRO = 'CREATE_MOTORISTA_CADASTRO'
export const CREATE_MOTORISTA_CADASTRO_PENDING = 'CREATE_MOTORISTA_CADASTRO_PENDING'
export const CREATE_MOTORISTA_CADASTRO_SUCCESS = 'CREATE_MOTORISTA_CADASTRO_SUCCESS'
export const CREATE_MOTORISTA_CADASTRO_FAILURE = 'CREATE_MOTORISTA_CADASTRO_FAILURE'

export const CANCEL_MOTORISTA_CADASTRO_RAPIDO = 'CANCEL_MOTORISTA_CADASTRO_RAPIDO'
export const CANCEL_MOTORISTA_CADASTRO_RAPIDO_SUCCESS = 'CANCEL_MOTORISTA_CADASTRO_RAPIDO_SUCCESS'

export const TABLE_MOTORISTA_CADASTRO = 'TABLE_MOTORISTA_CADASTRO'
export const TABLE_MOTORISTA_CADASTRO_PENDING = 'TABLE_MOTORISTA_CADASTRO_PENDING'
export const TABLE_MOTORISTA_CADASTRO_SUCCESS = 'TABLE_MOTORISTA_CADASTRO_SUCCESS'
export const TABLE_MOTORISTA_CADASTRO_FAILURE = 'TABLE_MOTORISTA_CADASTRO_FAILURE'

export const LIST_MOTORISTA_CADASTRO = 'LIST_MOTORISTA_CADASTRO'
export const LIST_MOTORISTA_CADASTRO_PENDING = 'LIST_MOTORISTA_CADASTRO_PENDING'
export const LIST_MOTORISTA_CADASTRO_SUCCESS = 'LIST_MOTORISTA_CADASTRO_SUCCESS'
export const LIST_MOTORISTA_CADASTRO_FAILURE = 'LIST_MOTORISTA_CADASTRO_FAILURE'

export const FIND_MOTORISTA_CADASTRO = 'FIND_MOTORISTA_CADASTRO'
export const FIND_MOTORISTA_CADASTRO_PENDING = 'FIND_MOTORISTA_CADASTRO_PENDING'
export const FIND_MOTORISTA_CADASTRO_SUCCESS = 'FIND_MOTORISTA_CADASTRO_SUCCESS'
export const FIND_MOTORISTA_CADASTRO_FAILURE = 'FIND_MOTORISTA_CADASTRO_FAILURE'

export const DELETE_MOTORISTA_CADASTRO = 'DELETE_MOTORISTA_CADASTRO'
export const DELETE_MOTORISTA_CADASTRO_PENDING = 'DELETE_MOTORISTA_CADASTRO_PENDING'
export const DELETE_MOTORISTA_CADASTRO_SUCCESS = 'DELETE_MOTORISTA_CADASTRO_SUCCESS'
export const DELETE_MOTORISTA_CADASTRO_FAILURE = 'DELETE_MOTORISTA_CADASTRO_FAILURE'
